// Common
export const HEADER_DEFAULT = {};

export const TIMEOUT = 1800000;

// HTTP Status
export const STT_OK = 200;
export const STT_CREATED = 201;
export const STT_BAD_REQUEST = 400;
export const STT_UNAUTHORIZED = 401;
export const STT_FORBIDDEN = 403;
export const STT_NOT_FOUND = 404;
export const STT_CONFLICT = 409;
export const STT_INTERNAL_SERVER = 500;
export const STT_NOT_MODIFIED = 304;

// Error code
export const ERROR_CODE_OK = "1";
export const DROPZONE_ERROR_CODE = {
  ERROR_MAX_SIZE: "file-too-large",
  ERROR_INVALID_TYPE: "file-invalid-type",
  ERROR_TOO_MANY_FILES: "too-many-files",
};

// Error Login Code
export const TENDANGNHAP_ERROR_CODE = "AEC_01";
export const MATKHAU_ERROR_CODE = "AEC_02";
export const KHOATAIKHOAN_ERROR_CODE = "AEC_03";

// API
export const AUTH_API = {
  POST_LOGIN: "/api/Auth/admin-login",
  POST_REFRESH_TOKEN: "/api/Auth/refresh-token",
  GET_PERMISSIONS: "/api/Auth/permissions",
  GET_CONFIG_DOMAIN: "/api/auth/config",
  POST_LOGOUT: "/api/Auth/logout",
  POST_CHANGE_PASSWORD: "/api/Auth/change-password",
};

// permission
export const PERMISSION_API = {
  GET_ALL: "/api/admin/permissions",
  POST: "/api/admin/permissions",
  PUT: "/api/admin/permissions",
  DELETE: "/api/admin/permissions",
};

export const COMMON_API = {
  GET_NOTIFICATION: "/v1/GET_NOTIFICATION",
  GET_TOTAL_NOTIFICATION_NOTSEEN: "/v1/GET_TOTAL_NOTIFICATION_NOTSEEN",
  POST_NOTIFICATION: "/v1/notification/seen",
  GET_GRADE_LEVELS: "/v1/organization/gradelevels",
  GET_SUBJECT_COMBO: "/v1/subject/subject-drop-down",
  GET_CURRICULUM_COMBO: "/v1/curriculum/curriculum-drop-down",
  GET_ORGANIZATION_NAME: "/v1/organization/dropdown",
  GET_LESION_DROPDOWN: "/v1/lesson/dropdown",
  GET_TEACHER_ADMIN_DROPDOWN: "/v1/account/organization/accounts/dropdown",

  // Danh sách chuẩn
  GET_STANDARD_SUBJECT_COMBO: "/v1/standard-subject/standard-subject-drop-down",
  GET_STANDARD_CURRICULUM_COMBO:
    "/v1/standard-curriculum/standard-curriculum-drop-down",
  GET_STANDARD_LESSON_COMBO: "/v1/standard-lesson/standard-lesson-drop-down",
};
export const HOME_API = {
  GET_BANNER: "/v1/GET_BANNER",
  GET_STATISTIC: "/v1/GET_STATISTIC",
  GET_LECTURES_NEW: "/v1/GET_LECTURES_NEW",
  GET_LECTURES_DANG_HOC: "/v1/GET_LECTURES_DANG_HOC",
  GET_CLASSONLINE_HOME: "/v1/GET_CLASSONLINE_HOME",
};

export const LECTURES_API = {
  GET_LECTURES: "api/lectures",
  GET_LECTURES_TOTAL: "api/lectures-total",
  GET_LECTURES_BY_ID: "api/lectures",
  POST_LECTURES: "api/lectures",
  PUT_LECTURES: "api/lectures",
  PATCH_LECTURES_STATUS: "api/lectures",
  DELETE_LECTURES: "api/lectures",
  GET_LECTURES_BLOCK: "v1/GET_LECTURES_BLOCK",
  GET_LECTURES_SUBJECTS: "v1/GET_LECTURES_SUBJECTS",
  GET_LECTURES_DETAIL: "v1/GET_LECTURES_DETAIL",
  GET_LECTURES_CONTENT_DETAIL: "v1/GET_LECTURES_CONTENT_DETAIL",
  POST_LECTURES_DETAIL_COMPLATE: "v1/POST_LECTURES_DETAIL_COMPLATE",
  POST_LECTURES_DETAIL_QUESTION: "v1/POST_LECTURES_DETAIL_QUESTION",
};
export const UPLOAD_API = {
  // POST_UPLOAD_IMG: "/api/upload/images",
  POST_UPLOAD_FILE: "/api/v1/media/lms/file",
};
export const CATEGORY_API = {
  DELETE: "api/category",
  GET_CATEGORY: "api/category",
  GET_CATEGORY_TOTAL: "api/category-total",
  GET_CATEGORY_BY_ID: "api/category",
  POST_CATEGORY: "api/category",
  PUT_CATEGORY: "api/category",
  PATCH_CATEGORY_STATUS: "api/category",
  GET_POINT_LADDER_DROPDOWN: "/v1/category/point-ladder/dropdown",
  GET_CATEGORY_GRADE_LEVELS: "/v1/category/gradelevels",
  GET_SHARE_TYPE: "/v1/category/sharetypes/dropdown",
};

// Bài học
export const LESSON_API = {
  GET_LIST: "/v1/lesson",
  GET_BY_ID: "/v1/lesson",
  POST: "/v1/lesson",
  PUT_EDIT: "/v1/lesson",
  DELETE_BY_ID: "/v1/lesson",
  GET_ASYNC_STANDARD_LESSON: "/v1/lesson/sync-standard-lessons",
};

// account
export const ACCOUNT_ADMIN_API = {
  GET: "/api/admin/users",
  POST: "/api/admin/users",
  GET_BY_ID: "/api/admin/users",
  DELETE: "/api/admin/users",
  PUT: "/api/admin/users",
  PATCH: "/api/admin/users",
};

export const WEB_USER_ADMIN_API = {
  GET: "/api/admin/web-users",
  GET_OPTIONS: "/api/admin/web-users/options",
  GET_ALL_OPTIONS: "/api/admin/web-users/all-options",
  GET_EXPORT: "/api/admin/web-users/export",
  POST: "/api/admin/web-users",
  POST_TOPUP: "/api/admin/web-users/topup",
  GET_TOPUP_HISTORY: "/api/admin/web-users/topup-history",
  GET_TOPUP_HISTORY_EXPORT: "/api/admin/web-users/topup-history/export",
  POST_BROADCAST_POINTS: "/api/admin/web-users/broadcast-points",
  GET_BROADCAST_POINTS_HISTORY: "/api/admin/web-users/broadcast-points-history",
  GET_BY_ID: "/api/admin/web-users",
  GET_FULL_DETAIL: "/api/admin/web-users",
  GET_RELATIONS: "/api/admin/web-users",
  GET_WITHDRAWAL_REQUESTS: "/api/admin/web-users/withdrawal-requests",
  GET_WITHDRAWAL_REQUESTS_EXPORT: "/api/admin/web-users/withdrawal-requests/export",
  GET_PACKAGE_REWARD_JOBS: "/api/admin/web-users/package-reward-jobs",
  GET_PACKAGE_REWARD_JOBS_EXPORT: "/api/admin/web-users/package-reward-jobs/export",
  GET_SEPAY_TOPUP_ORDERS: "/api/admin/web-users/sepay-topup-orders",
  GET_SEPAY_TOPUP_ORDERS_EXPORT: "/api/admin/web-users/sepay-topup-orders/export",
  GET_PRODUCT_PURCHASES: "/api/admin/web-users/product-purchases",
  GET_PRODUCT_PURCHASES_EXPORT: "/api/admin/web-users/product-purchases/export",
  DELETE: "/api/admin/web-users",
  DELETE_TOPUP_HISTORY: "/api/admin/web-users/topup-history",
  DELETE_BROADCAST_POINTS_HISTORY:
    "/api/admin/web-users/broadcast-points-history",
  PUT: "/api/admin/web-users",
  PUT_PASSWORD: "/api/admin/web-users",
  PATCH_LOCK: "/api/admin/web-users",
  PATCH_UNLOCK: "/api/admin/web-users",
  PATCH_WITHDRAWAL_REQUEST_COMPLETE: "/api/admin/web-users/withdrawal-requests",
  PATCH_WITHDRAWAL_REQUEST_REJECT: "/api/admin/web-users/withdrawal-requests",
  PATCH_PRODUCT_PURCHASE_COMPLETE: "/api/admin/web-users/product-purchases",
  PATCH_PRODUCT_PURCHASE_REJECT: "/api/admin/web-users/product-purchases",
};

export const ADMIN_DASHBOARD_API = {
  GET: "/api/admin/dashboard",
};

export const PROFILE_API = {
  GET_DASHBOARD: "/api/profile",
  GET_BANK_OPTIONS: "/api/profile/banks/options",
  GET_PURCHASE_PACKAGE_CONTEXT: "/api/profile/purchase-package",
  POST_PURCHASE_PACKAGE: "/api/profile/purchase-package",
  GET_EDIT_INFO: "/api/profile/edit-info",
  PUT_EDIT_INFO: "/api/profile/edit-info",
  GET_WITHDRAW_POINTS_CONTEXT: "/api/profile/withdraw-points",
  POST_WITHDRAW_POINTS: "/api/profile/withdraw-points",
  GET_WITHDRAWAL_HISTORY: "/api/profile/withdrawal-history",
  GET_REWARD_HISTORY: "/api/profile/reward-history",
  GET_STRUCTURE_MEMBERS: "/api/profile/members/structure",
  GET_GENERATION_MEMBERS: "/api/profile/members/generation",
  GET_CREATE_MEMBER_CONTEXT: "/api/profile/members/create",
  POST_CREATE_MEMBER: "/api/profile/members",
  GET_PRODUCT_PURCHASE_CONTEXT: "/api/profile/products/purchase",
  POST_PRODUCT_PURCHASE: "/api/profile/products/purchase",
  GET_PRODUCT_PURCHASES: "/api/profile/products",
};

// activity log
export const ACTIVITY_LOG_API = {
  GET: "/v1/activitylog",
};

// Role
export const ROLE_API = {
  GET: "/api/admin/roles",
  POST: "/api/admin/roles",
  GET_BY_ID: "/api/admin/roles",
  DELETE: "/api/admin/roles",
  PUT: "/api/admin/roles",
};

export const WALLET_REPORT_GROUP_API = {
  GET: "/api/admin/wallet-report-groups",
  GET_BY_ID: "/api/admin/wallet-report-groups",
  POST: "/api/admin/wallet-report-groups",
  PUT: "/api/admin/wallet-report-groups",
  DELETE: "/api/admin/wallet-report-groups",
  GET_WALLET_TYPE_OPTIONS: "/api/admin/wallet-report-groups/wallet-types/options",
  PUT_REORDER: "/api/admin/wallet-report-groups/reorder",
};

export const REWARD_RATE_SETTING_API = {
  GET: "/api/admin/reward-rate-settings",
  PUT: "/api/admin/reward-rate-settings",
};

export const SYSTEM_SETTING_API = {
  GET_GENERAL: "/api/admin/system-settings/general",
  PUT_GENERAL: "/api/admin/system-settings/general",
};

export const BANK_API = {
  GET: "/api/admin/banks",
  POST: "/api/admin/banks",
  PUT: "/api/admin/banks",
  DELETE: "/api/admin/banks",
};
